import { Typography, Box, SxProps, Theme } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useCountUp } from 'react-countup';
import { useTranslation } from 'react-i18next';
import { RoundedPaper } from '../../lib/components';
import { ArrowRaisedRightIcon, InfoIcon } from '../../lib/icons';
import Util from '../../misc/util';
import { TooltipComponent } from '../../lib/components/atomic/feedback';

interface BenefitCardProps {
  value?: number;
  sx?: SxProps<Theme>;
}

export const BenefitCard: FC<BenefitCardProps> = ({ value = 0, sx }) => {
  const { t } = useTranslation('calculator');

  const [oldValue, setOldValue] = useState(0);
  const counter = useCountUp({
    ref: 'value',
    start: oldValue,
    end: value,
    formattingFn: (value) => Util.formatCurrency(value, false),
    duration: 1,
    startOnMount: false
  });

  useEffect(() => {
    counter.getCountUp().startVal = oldValue;
    counter.update(value);
    setOldValue(value);
    counter.start();
  }, [value]);

  return (
    <RoundedPaper
      sx={{ padding: '1.25rem', backgroundColor: 'success.main', color: 'white', ...sx }}
    >
      <Box display="flex">
        <Typography variant="h3" color="inherit">
          {t('BENEFIT_CARD_TITLE')}
        </Typography>
        <TooltipComponent title={t('MONTHLY')} placement="right" arrow>
          <Box paddingLeft="8px" maxWidth="fit-content">
            <InfoIcon height={28} width={18} />
          </Box>
        </TooltipComponent>
      </Box>
      <Box display="flex" paddingTop="1rem">
        <ArrowRaisedRightIcon
          height={28}
          width={28}
          color="success.main"
          sx={{
            backgroundColor: 'white',
            borderRadius: '18px',
            padding: '4px'
          }}
        />
        <Typography
          variant="h1"
          id="value"
          sx={{
            fontWeight: 'bold',
            color: 'inherit',
            fontSize: '40px',
            lineHeight: '36px',
            paddingLeft: '1rem'
          }}
        />
      </Box>
    </RoundedPaper>
  );
};
